
import { useEffect } from "react";
import {
  getFacebookLoginStatus,
  initFacebookSdk,
  fbLogin,
} from "../../controllers/FacebookSDK";

export default function FBInit() {
  useEffect(() => {
    console.log("FBSDK: Started use effect");
    initFB();
  }, []);

  async function initFB () {
    console.log("FBSDK: initing.");
    try {
      await initFacebookSdk();
    }
    catch(e) {
      console.error(e);
    }
    console.log("FBSDK: inited.");
    let response = await getFacebookLoginStatus();
    if (response == null) {
      console.log("FBSDK:: No login status for the person");
    } else {
      console.log('FBSDK:', response);
    }
  }

  function login() {
    console.log("reached log in button");
    fbLogin().then((response) => {
      console.log(response);
      if (response.status === "connected") {
        console.log("Person is connected");
      } else {
        // something
      }
    });
  }



  return (
    <div>
      <div id="fb-root"></div>
      <script async defer crossorigin="anonymous" src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v23.0&appId=1300460478088242"></script>
      {/* <button onClick={login}>Login</button> */}
      <div className="fb-page" data-href="https://www.facebook.com/FamiliasEnMisionApostolica" data-tabs="timeline" data-width="330" data-height="" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"><blockquote cite="https://www.facebook.com/FamiliasEnMisionApostolica" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/FamiliasEnMisionApostolica">Familias en Misión Apostólica</a></blockquote></div>
    </div>
  );
}